module.exports = __webpack_public_path__ + "static/img/contentRightImg1.de82622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg1.jpg
// module id = x+lG
// module chunks = 2